import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GrUserAdmin } from 'react-icons/gr';
import { MdOutlinePeople, MdOutlineGrid3X3, MdOutlineSecurity, MdOutlineList, MdOutlineDeleteSweep } from 'react-icons/md';
import PermissionGuard from './PermissionGuard';
import { PERMISSIONS } from '../hooks/usePermissions';
import './AdminSidebar.css';

const AdminSidebar = ({ onClose, isMainSidebarCollapsed }) => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className={`admin-sidebar ${isMainSidebarCollapsed ? 'main-sidebar-collapsed' : ''}`}>
      <div className="admin-sidebar-header">
        <div className="admin-sidebar-title">
          <div className="admin-sidebar-title-text">
            <GrUserAdmin size={18} />
            <span>Admin Portal</span>
          </div>
        </div>
        <button className="close-btn" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      <nav className="admin-sidebar-nav">
        {/* Users - Requires USER_LIST permission */}
        <PermissionGuard permission={PERMISSIONS.USER_LIST}>
          <Link 
            to="/admin/users" 
            className={`admin-nav-item ${isActive('/admin/users') ? 'active' : ''}`}
          >
            <MdOutlinePeople size={18} />
            <span>Users</span>
          </Link>
        </PermissionGuard>

        {/* Practices - Requires PRACTICE_LIST permission */}
        <PermissionGuard permission={PERMISSIONS.PRACTICE_LIST}>
          <Link 
            to="/admin/practices" 
            className={`admin-nav-item ${isActive('/admin/practices') ? 'active' : ''}`}
          >
            <MdOutlineGrid3X3 size={18} />
            <span>Practices</span>
          </Link>
        </PermissionGuard>

        {/* Roles & Permissions - Requires ROLE_LIST permission */}
        <PermissionGuard permission={PERMISSIONS.ROLE_LIST}>
          <Link 
            to="/admin/roles" 
            className={`admin-nav-item ${isActive('/admin/roles') ? 'active' : ''}`}
          >
            <MdOutlineSecurity size={18} />
            <span>Roles & Permissions</span>
          </Link>
        </PermissionGuard>

        {/* Master Data - Requires ADMIN_PORTAL_DASHBOARD_VIEW permission */}
        <PermissionGuard permission={PERMISSIONS.ADMIN_PORTAL_DASHBOARD_VIEW}>
          <Link 
            to="/admin/master-data" 
            className={`admin-nav-item ${isActive('/admin/master-data') ? 'active' : ''}`}
          >
            <MdOutlineList size={18} />
            <span>Master Data</span>
          </Link>
        </PermissionGuard>

        {/* Check Trash - Requires ADMIN_PORTAL_DASHBOARD_VIEW permission */}
        <PermissionGuard permission={PERMISSIONS.ADMIN_PORTAL_DASHBOARD_VIEW}>
          <Link 
            to="/admin/check-trash" 
            className={`admin-nav-item ${location.pathname.startsWith('/admin/check-trash') ? 'active' : ''}`}
          >
            <MdOutlineDeleteSweep size={18} />
            <span>Check Trash</span>
          </Link>
        </PermissionGuard>
      </nav>
    </div>
  );
};

export default AdminSidebar;

